export default "__VITE_ASSET__bOcj7laC__"